import { render, staticRenderFns } from "./index.vue?vue&type=template&id=334bd39b"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('334bd39b')) {
      api.createRecord('334bd39b', component.options)
    } else {
      api.reload('334bd39b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=334bd39b", function () {
      api.rerender('334bd39b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/pages/database/index.vue"
export default component.exports